export const UPLOAD_MAINTENANCE_CHECKS_MODAL_WIZARD_PAGE = {
  PAGE_1_CHOOSE_FILE: 0,
  PAGE_2_VERIFICATION: 1,
  PAGE_3_PROCESSING: 2,
} as const;
export type UPLOAD_MAINTENANCE_CHECKS_MODAL_WIZARD_PAGE = typeof UPLOAD_MAINTENANCE_CHECKS_MODAL_WIZARD_PAGE;
export type AN_UPLOAD_MAINTENANCE_CHECKS_MODAL_WIZARD_PAGE = UPLOAD_MAINTENANCE_CHECKS_MODAL_WIZARD_PAGE[keyof UPLOAD_MAINTENANCE_CHECKS_MODAL_WIZARD_PAGE];
